<template>
  <div class="relative" data-aos="fade-left" data-aos-delay="100">
    <div
      class="absolute inset-0 bg-gradient-to-r from-[#ffb47c] to-[#0b105d] rounded-2xl sm:rounded-3xl blur-xl opacity-30"
    ></div>
    <div class="relative glass-morphism-dark rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 h-full">
      <h2 class="text-2xl sm:text-3xl font-bold text-[#f4f4f4] mb-6 sm:mb-8">
        {{ $t('contactPage.contactInfoTitle') }}
      </h2>

      <div class="space-y-6 sm:space-y-8">
        <!-- Address -->
        <div class="group">
          <div class="flex items-center gap-3 sm:gap-4">
            <div
              class="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-[#fe6d0d] to-[#ffb47c] rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform shadow-lg"
            >
              <MapPinIcon class="h-5 w-5 sm:h-6 sm:w-6 text-white" />
            </div>
            <div class="min-w-0 flex-1">
              <!--<h4 class="font-semibold text-[#f4f4f4] mb-1 text-sm sm:text-base">
                {{ $t('footer.address').split(':')[0] || 'Address' }}
              </h4>
              <p class="text-[#f4f4f4]/80 text-sm sm:text-base leading-relaxed">
                {{
                  $t('footer.address').includes(':')
                    ? $t('footer.address')
                        .substring($t('footer.address').indexOf(':') + 1)
                        .trim()
                    : $t('footer.address')
                }}
              </p>-->
              <p class="text-[#f4f4f4]/80 text-sm sm:text-base leading-relaxed">
                {{
                   $t('footer.address')
                }}
              </p>
            </div>
          </div>
        </div>

        <!-- Phone -->
        <div class="group">
          <div class="flex items-center gap-3 sm:gap-4">
            <div
              class="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-[#fe6d0d] to-[#ffb47c] rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform shadow-lg"
            >
              <PhoneIcon class="h-5 w-5 sm:h-6 sm:w-6 text-white" />
            </div>
            <div class="min-w-0 flex-1">
              <!--<h4 class="font-semibold text-[#f4f4f4] mb-1 text-sm sm:text-base">
                {{ $t('footer.phone').split(':')[0] || 'Phone' }}
              </h4>-->
              <a
                :href="
                  'tel:' +
                  ($t('footer.phone').includes(':')
                    ? $t('footer.phone')
                        .substring($t('footer.phone').indexOf(':') + 1)
                        .trim()
                    : $t('footer.phone'))
                "
                class="text-[#f4f4f4]/80 hover:text-[#ffb47c] transition-colors text-sm sm:text-base"
              >
                {{
                  $t('footer.phone').includes(':')
                    ? $t('footer.phone')
                        .substring($t('footer.phone').indexOf(':') + 1)
                        .trim()
                    : $t('footer.phone')
                }}
              </a>
            </div>
          </div>
        </div>

        <!-- Email -->
        <div class="group">
          <div class="flex items-center gap-3 sm:gap-4">
            <div
              class="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-[#fe6d0d] to-[#ffb47c] rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform shadow-lg"
            >
              <MailIcon class="h-5 w-5 sm:h-6 sm:w-6 text-white" />
            </div>
            <div class="min-w-0 flex-1">
              <!-- <h4 class="font-semibold text-[#f4f4f4] mb-1 text-sm sm:text-base">
                {{ $t('footer.email').split(':')[0] || 'Email' }}
              </h4>-->
              <a
                :href="
                  'mailto:' +
                  ($t('footer.email').includes(':')
                    ? $t('footer.email')
                        .substring($t('footer.email').indexOf(':') + 1)
                        .trim()
                    : $t('footer.email'))
                "
                class="text-[#f4f4f4]/80 hover:text-[#ffb47c] transition-colors text-sm sm:text-base break-all"
              >
                {{
                  $t('footer.email').includes(':')
                    ? $t('footer.email')
                        .substring($t('footer.email').indexOf(':') + 1)
                        .trim()
                    : $t('footer.email')
                }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Map -->
      <div
        class="mt-8 sm:mt-10 relative rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl"
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        <div
          class="absolute inset-0 bg-gradient-to-br from-[#fe6d0d]/20 to-[#ffb47c]/20 z-10 pointer-events-none"
        ></div>
        <iframe :src="
          $t('contactPage.mapAddressLink')
          "
          width="100%"
          height="250"
          style="border: 0"
          allowfullscreen="true"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          class="filter grayscale contrast-120 opacity-80 hover:opacity-100 hover:grayscale-0 transition-all duration-500"
        ></iframe>
      </div>

      <!-- Social Links -->
      <div class="mt-8 sm:mt-10 pt-6 sm:pt-8 border-t border-[#f4f4f4]/10">
        <h4 class="text-base sm:text-lg font-semibold text-[#f4f4f4] mb-3 sm:mb-4">
          {{ $t('contactPage.contactUs') }}
        </h4>
        <div class="flex gap-3">
          <a
            v-for="social in socialLinks"
            :key="social.name"
            :href="social.href"
            class="group"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              class="w-9 h-9 sm:w-10 sm:h-10 bg-[#f4f4f4]/10 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-[#fe6d0d] hover:to-[#ffb47c] transition-all duration-300 transform hover:scale-110 shadow-sm"
            >
              <component :is="social.icon" class="w-4 h-4 sm:w-5 sm:h-5 text-[#f4f4f4]" />
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconX from '@/components/icons/IconX.vue'
import { Facebook, Linkedin, Instagram, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-vue-next'

const socialLinks = [
  { name: 'Facebook', href: 'https://facebook.com/torukmagic', icon: Facebook },
  { name: 'X', href: 'https://x.com/torukmagic', icon: IconX },
  { name: 'LinkedIn', href: 'https://linkedin.com/torukmagic', icon: Linkedin },
  { name: 'Instagram', href: 'https://instagram.com/torukmagic', icon: Instagram },
]
</script>

<style scoped>
.glass-morphism-dark {
  background: rgba(244, 244, 244, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(244, 244, 244, 0.1);
}
</style>
